// extracted by mini-css-extract-plugin
export default {"wrapper":"IRwSA__wrapper","comment":"lBp4S__comment","childCommentWrapper":"Ln88G__childCommentWrapper"};